import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { FormControl } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';
import { BatchWiseFeesDetailsNewpdf } from "./Document/BatchWiseFeesDetailsNewpdf";
import { pdf } from "@react-pdf/renderer";
import * as XLSX from 'xlsx';
import FeesRecordNew from "./Document/FeesRecordNew";
import BatchWiseFacultyPayment from "./Document/BatchWiseFacultyPayment";

const FeesDetails = () => {

    const [course, SetCourse] = useState([])
    const [batch, setBatch] = useState([]);
    const [brand, setBrand] = useState([])
    const [vendordata, setVendorData] = useState([])
    const [data, setData] = useState([])
    const [error, setError] = useState({})
    const [category, setCat] = useState("batchwise");
    const [value, setValue] = useState({
        course: "",
        batch: "",
    })






    const validateForm = () => {
        let isValid = true
        const newErrors = {}

        if (!value.course) {
            isValid = false;
            newErrors.course = "Course is RequireD"
        }
        if (!value.batch) {
            isValid = false;
            newErrors.batch = "Batch is Required";
        }
        setError(newErrors)
        return isValid
    }


    async function getEmployeeData() {

        axios.post(`${BASE_URL}/vendor_details`)
            .then((res) => {
                console.log(res.data)
                setBrand(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }



    async function getEmployeeData() {
        const data = {
            tablename: "awt_employeerecord"
        }
        axios.post(`${BASE_URL}/get_data`, data)
            .then((res) => {
                console.log(res.data)
                setVendorData(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }



    async function getCourseData() {
        axios
            .get(`${BASE_URL}/getCourse`)
            .then((res) => {
                SetCourse(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }
    useEffect(() => {
        getEmployeeData()
        getCourseData();
        setError({})
    }, [])



    const handleSubmit = (e) => {
        e.preventDefault()

        if (validateForm()) {
            generatePdf();
        }

    }

    const generatePdf = () => {
        switch (category) {
            case "batchwise":
                batchwisefeesdetailsnewpdf();
                break;
            case "feesrecord":
                feesrecordnewpdf();
                break;
            case "facultypayment":
                facultypaymentpdf();
                break;
        }
    }

    const handlegetbatch = async (courseid) => {
        setValue({
            course: courseid,
        });

        try {
            const res = await axios.post(`${BASE_URL}/getcoursewisebatch`, { courseid: courseid });


            setBatch(res.data);
        } catch (err) {
            console.error("Error fetching data:", err);
        }
    };

    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }


    const feesrecordnewpdf = async () => {

        try {
            const res = await axios.post(`${BASE_URL}/getfeesrecordpdf`, { batch_code: value.batch , course : value.course });
            const blob = await pdf(<FeesRecordNew data={res.data} />).toBlob();
            const url = URL.createObjectURL(blob);
            window.open(url);
            URL.revokeObjectURL(url);

        } catch (err) {
            console.log(err)
        }

    };

    const facultypaymentpdf = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/getbatchwisefacultypayment`, { batch_code: value.batch });
            const blob = await pdf(<BatchWiseFacultyPayment data={res.data} />).toBlob();
            const url = URL.createObjectURL(blob);
            window.open(url);
            URL.revokeObjectURL(url);

        } catch (err) {
            console.log(err)
        }

    };

    const batchwisefeesdetailsnewpdf = async () => {
        try {

            const res = await axios.post(`${BASE_URL}/getbatchwisefees`, { batch_code: value.batch });
            setData(res.data)
            const blob = await pdf(<BatchWiseFeesDetailsNewpdf batchwisefee={res.data} />).toBlob();
            const url = URL.createObjectURL(blob);
            window.open(url);
            URL.revokeObjectURL(url);

        } catch (err) {
            console.log(err)
        }

    };

    const exporttoexcel = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/getbatchwisefees`, { batch_code: value.batch });
            const originalData = res.data;

            // Step 1: Preprocess data to calculate Balance = Fees_Full_Payment - Amount
            const processedData = originalData.map(item => ({
                Student_Id: item.Student_Id,
                Student_Name: item.Student_Name,
                SDate: item.SDate,
                EDate: item.EDate,
                Batch_code: item.Batch_code,
                Batch_Category: item.Category,
                Amount: item.Amount,
                Paid_Amount: item.Total_Amt,
                Remaining_Amount: (Number(item.Fees_Full_Payment) || 0) - (Number(item.Amount) || 0),
                Course_Name: item.Course_Name,
            }));

            // Step 2: Convert JSON to worksheet
            const worksheet = XLSX.utils.json_to_sheet(processedData);

            // Step 3: Create workbook and append worksheet
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'BatchWiseFees');

            // Step 4: Export the Excel file
            XLSX.writeFile(workbook, 'BatchWiseFeesDetails.xlsx');

        } catch (err) {
            console.log(err);
        }
    };




    return (
        <div className="container-fluid page-body-wrapper ">
            <InnerHeader />
            <div className="main-panel">

                <div className="content-wrapper">
                    <div className="row">
                        <div className="col-lg-12 grid-margin">
                            <div class="d-flex">

                                <div className='px-2 mx-2'><Link to="/feesreport"><h4>Cheque/PDC and Receipts</h4></Link></div>
                                <div className='px-2 mx-2'><Link to="/feesdetails"><h4>Fees Details</h4></Link></div>
                                <div className='px-2 mx-2'><Link to="/facultypayment"><h4>Faculty Payment Detail Report</h4></Link></div>
                            </div>
                            <div className="card">
                                <div className='container-fluid'>
                                    <div className='row d-flex justify-content-between'>

                                        <div className='col-lg-12'>
                                            <div className='row justify-content-center' >
                                                <div className='p-3' style={{ width: "100%" }}>
                                                    <form class="form-sample py-3" onSubmit={handleSubmit}>
                                                        <div class="row">
                                                            <div class="form-group col-lg-12">
                                                                <FormControl>
                                                                    <RadioGroup

                                                                        row aria-labelledby='demo-row-radio-button-group-lable'
                                                                        name='row-radio-button-group' value={category}>
                                                                        <FormControlLabel value="batchwise" control={<Radio />} label="Batch Wise Fees Details New" onChange={(e) => setCat(e.target.value)} />
                                                                        <FormControlLabel value="feesrecord" onChange={(e) => setCat(e.target.value)} control={<Radio />} label="Fees Record New" />
                                                                        <FormControlLabel value="facultypayment" onChange={(e) => setCat(e.target.value)} control={<Radio />} label="Batch Wise Faculty Payment" />

                                                                    </RadioGroup>

                                                                </FormControl>
                                                            </div>

                                                            <div class="form-group col-lg-3">
                                                                <label for="exapmleFormControlSelect1">Course<span className="text-danger">*</span></label>
                                                                <select
                                                                    class="form-control form-control-lg"
                                                                    id="exampleFormControlSelect1"
                                                                    onChange={(e) => handlegetbatch(e.target.value)}
                                                                    name="course"
                                                                >
                                                                    <option>Select Course</option>
                                                                    {course.map((item) => {
                                                                        return (
                                                                            <option value={item.Course_Id}>{item.Course_Name}</option>
                                                                        );
                                                                    })}
                                                                </select>
                                                                {<span className="text-danger"> {error.course} </span>}
                                                            </div>

                                                            <div class="form-group col-lg-3">
                                                                <lable for="exampleFormControlSelect1">Select Batch<span className="text-danger">*</span></lable>
                                                                <select
                                                                    class="form-control form-control-lg"
                                                                    id="exampleFormControlSelect1"
                                                                    onChange={onhandleChange}
                                                                    name="batch"
                                                                >
                                                                    <option>Select Batch</option>

                                                                    {batch.map((item) => {
                                                                        return (
                                                                            <option value={item.Batch_code}>{item.Batch_code}</option>
                                                                        );
                                                                    })}
                                                                </select>
                                                                {<span className="text-danger"> {error.batch} </span>}
                                                            </div>


                                                            {category == 'batchwise' && <div class="form-group col-lg-3">
                                                                <lable for="exampleFormControlSelect1">Select Amount Type</lable>
                                                                <select class="form-control" id="exampleFormCpntrolSelect1" value={value.amounttype}
                                                                    name='amounttype' onChange={onhandleChange}>
                                                                    <option>All</option>
                                                                    <option>Remaining Amount</option>
                                                                </select>
                                                            </div>}


                                                            {category == 'batchwise' && <div class='p-4'>
                                                                <button type="button" className='mr-2 btn btn-primary' onClick={exporttoexcel}>Excel</button>
                                                            </div>}

                                                        </div>

                                                        <div className='row p-2 gap-2'>
                                                            <button className='mr-2 btn btn-primary' onClick={handleSubmit}>Show</button>
                                                        </div>


                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default FeesDetails